import React, { useEffect, useRef, useState } from "react";

export default function EmailCell({ value, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const ref = useRef(null);

  useEffect(() => { setDraft(value || ""); }, [value]);
  useEffect(() => { if (editing) ref.current?.focus(); }, [editing]);

  const commit = () => {
    setEditing(false);
    const next = draft.trim();
    if (next === (value || "")) return;
    if (!next) {
      onCommit(null);
      return;
    }
    onCommit(next);
  };

  if (editing && !readOnly) {
    return (
      <input
        ref={ref}
        type="email"
        className="cell-input"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") setEditing(false);
        }}
      />
    );
  }

  return (
    <div className={`cell-display email ${readOnly ? "read-only" : ""}`}>
      {value ? (
        <>
          <a
            href={`mailto:${value}`}
            className="email-link"
            onClick={(e) => e.stopPropagation()}
          >
            {value}
          </a>
          {!readOnly && (
            <button className="link-edit-btn" onClick={() => setEditing(true)} title="Edit">✎</button>
          )}
        </>
      ) : (
        <span className="placeholder" onClick={() => !readOnly && setEditing(true)}>—</span>
      )}
    </div>
  );
}
